import React, { useState, useEffect, useRef, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  SemanticTable,
  ContainerInputSearch,
  Input,
} from "./styles";
import swal from "sweetalert";
import { withRouter, Link } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { cleanTagsHtml } from "../../../../utils/Utils";
import { isAuthAdmin } from "../../../../services/auth";

const ListarSimulados = (props) => {
  const [simulados, setSimulados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const area = useRef([]);

  useEffect(() => {
    loadAuth();
    loadArea();
    loadSimulados();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadSimulados = async () => {
    await api
      .get(`/simulado`)
      .then(async (res) => {
        let logs = { local: "simulado", texto: `listou os simulados` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setSimulados(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os simulados", err, "error");
        setLoading(false);
      });
  };
  const loadArea = async () => {
    await api
      .get(`area-descricao`)
      .then((res) => {
        area.current = res.data;
      })
      .catch((err) => {
        swal("Não foi possível carregar as areas", err, "error");
      });
  };

  const removeSimulado = useCallback(
    (id) => {
      swal(
        "Remoção de Simulados",
        "Você tem certeza que quer remover? ",
        ""
      ).then((res) => {
        if (res) {
          api.delete(`/admin/simulado/${id}`).then(async (res) => {
            let array = {
              local: "simulado",
              texto: `deletou o simulado de id=${id}`,
            };
            await api.post("system_logs", { acao: JSON.stringify(array) });
            const newSimulados = [...simulados].filter(
              (simulado) => simulado.id !== id
            );
            setSimulados(newSimulados.reverse());
          });
        }
      });
    },
    [simulados]
  );

  const modifyString = (value) => {
    const newValue = cleanTagsHtml(value.substr(0, 30));
    return `${newValue}...`;
  };
  const modifyArea = (value) => {
    const newArray = area.current.filter((teste) => teste.id_area == value);
    if (newArray != null) {
      return newArray[0].areacorp.nome_tab;
    }
  };
  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Conteúdos das Páginas (simulados)</Title>
            <ContainerInputSearch>
              <Input
                type="text"
                placeholder="Pesquise pelo titulo"
                onChange={(e) => setSearch(e.target.value)}
              />
              <Link to="/admin/simulados/criar">
                <Button>Criar</Button>
              </Link>
            </ContainerInputSearch>
            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Area</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Titulo</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Url</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Descrição</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Imagem</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Instrução</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              {simulados.length > 0 ? (
                <SemanticTable.Body>
                  {simulados
                    .reverse()
                    .filter((simulado) =>
                      simulado.titulo
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    )
                    .map((simulado, index) => (
                      <SemanticTable.Row>
                        <SemanticTable.Cell>{simulado.id}</SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {modifyArea(simulado.id_area_corporativa)}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {simulado.titulo}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>{simulado.url}</SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {modifyString(simulado.descricao)}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {modifyString(simulado.imagem)}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {modifyString(simulado.instrucao)}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          <>
                            <Button
                              icon="edit icon"
                              size="small"
                              color={"blue"}
                              onClick={() =>
                                window.open(
                                  `/admin/simulados/detalhes/${simulado.id}`
                                )
                              }
                            />
                            <Button
                              icon="trash icon"
                              size="small"
                              color={"red "}
                              onClick={() => removeSimulado(simulado.id)}
                            />
                          </>
                        </SemanticTable.Cell>
                      </SemanticTable.Row>
                    ))}
                </SemanticTable.Body>
              ) : (
                <h3>Nenhum Simulado encontrado</h3>
              )}
            </SemanticTable>
          </Content>
        )}
        ;
      </Container>
    </>
  );
};

export default withRouter(ListarSimulados);
